<template>
  <v-app>
    <main-header v-if="!$route.meta.isNoHeader"/>
    <v-row :class="['contents', {'user-contents' : $route.meta.isUserMain}, {'no-header': $route.meta.isNoHeader} ]">
      <v-row>
        <left-menu v-if="!$route.meta.isNoLeftMenu" />
        <router-view />
      </v-row>
    </v-row>
    <confirm-popup/>
    <alert/>
    <loading/>
  </v-app>
</template>

<script>
import MainHeader from './components/layout/MainHeader'
import LeftMenu from './components/layout/LeftMenu'
import ConfirmPopup from './components/common/ConfirmPopup'
import Alert from './components/common/Alert'
import Loading from './components/common/Loading'

export default {
  name: 'App',
  components: {
    MainHeader,
    LeftMenu,
    Alert,
    ConfirmPopup,
    Loading
  }
}
</script>
<style lang="scss">
  @import "assets/style/style";
  @include left-menu;
  @include content-menu;

  /* 라이트 모드 (기본 상태) */
  :root {
    --bg-color: #ffffff;
    --text-color: #1a212f;
    --card-bg: #f9f9f9;
    --border-color: #eeeeee;
    --border-color-2: #dddddd;
  }

  :root.dark-theme {
    --bg-color: #121212;
    --text-color: #eeeeee;
    --card-bg: #1e1e1e;
    --border-color: #444444;
    --border-color-2: #666666;
  }

  .dark-theme body {
    background-color: var(--bg-color);
    color: var(--text-color);
  }

  .dark-theme .status-card {
    background-color: var(--card-bg);
    border-color: var(--border-color);
    color: var(--text-color);
  }

  .dark-theme .car-ui-wrapper {
    background-color: var(--bg-color);
    color: var(--text-color);
  }

  .dark-theme .input-display,
  .dark-theme .input-display-empty {
    color: var(--text-color);
  }
</style>
